import _sum from "lodash/sum";
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import { getValidationMessagesForStandaloneItems } from 'swag-client-common/utils/validations';
import { checkIsApparel, getTotalCount } from 'swag-client-common/utils/product.utils';
import { subtractQuantities } from 'swag-client-common/utils/order-item.utils';
import { editingQuantityInCartSelector, editQuantityInCartItemDataSelector, getAvailableQuantities, isOpenEditQuantityInCartPopup, productCardItemsSelector } from '../../../redux/box-builder/box-builder.selectors';
import { closeEditQuantityInCartPopup, editCurrentQuantityInCart, saveNewQuantityInCartForItemProductCard } from '../../../redux/box-builder/box-builder.actions';
import { cartItemsSelector, stockLevelsByProductIdAndVariantSkuSelector, supplierInventoryLevelsCartAndDraftSelector } from '../../../redux/cart/cart.selectors';
import EditQuantityInCartForBuildBoxesDrawer from './edit-quantity-in-cart-for-build-boxes-drawer';
const currentItemSelector = createSelector(editQuantityInCartItemDataSelector, cartItemsSelector, (editQuantityInCartItemData, cartItems) => {
  if (!editQuantityInCartItemData) {
    return null;
  }
  return cartItems.find(item => item._id === editQuantityInCartItemData.itemId);
});
const currentProductSelector = createSelector(currentItemSelector, currentItem => {
  return currentItem === null || currentItem === void 0 ? void 0 : currentItem.prod;
});
const currentProductCardItemSelector = createSelector(editQuantityInCartItemDataSelector, productCardItemsSelector, editingQuantityInCartSelector, (editQuantityInCartItemData, productCardItems) => {
  if (!editQuantityInCartItemData) {
    return null;
  }
  const {
    itemId,
    variantIndex
  } = editQuantityInCartItemData;
  return productCardItems.find(productCardItem => productCardItem.itemId === itemId && variantIndex === productCardItem.variant.variantIndex);
});
const totalQuantitiesSelector = createSelector(currentProductCardItemSelector, currentProductCardItem => {
  if (!currentProductCardItem) {
    return [];
  }
  const {
    quantitiesInThisBox
  } = currentProductCardItem;
  return currentProductCardItem.cartQuantities.map((quantity, index) => {
    if (!quantitiesInThisBox) {
      return quantity;
    }
    return quantity + (quantitiesInThisBox[index] || 0);
  });
});
const initialProductCardQuantitiesSelector = createSelector(currentProductCardItemSelector, totalQuantitiesSelector, (currentProductCardItem, totalAvailableQuantities) => {
  if (!currentProductCardItem) {
    return [];
  }
  return subtractQuantities({
    decreasingQuantity: totalAvailableQuantities,
    // @todo. auto generated. fix this error
    // @ts-ignore
    subtractionQuantity: currentProductCardItem.quantityPerBox > 0 ? currentProductCardItem.quantitiesItem : []
  });
});
const variantSelector = createSelector(currentProductCardItemSelector, editingQuantityInCartSelector, initialProductCardQuantitiesSelector, (currentProductCardItem, editingQuantityInCart, initialProductCardQuantities) => {
  return currentProductCardItem ? _objectSpread({}, currentProductCardItem.variant, {
    quantities: editingQuantityInCart || initialProductCardQuantities
  }) : null;
});
const stockLevelsByVariantSkuSelector = createSelector(stockLevelsByProductIdAndVariantSkuSelector, currentProductSelector, (stockLevelsByProductIdAndVariantSku, currentProduct) => {
  if (!currentProduct) {
    return {};
  }
  return stockLevelsByProductIdAndVariantSku[currentProduct._id] || {};
});
const errorMessageSelector = createSelector(currentItemSelector, variantSelector, stockLevelsByProductIdAndVariantSkuSelector, supplierInventoryLevelsCartAndDraftSelector, currentProductCardItemSelector, (item, variant, stockLevelsByProductIdAndVariantSku, supplierInventoryLevels, currentProductCardItem) => {
  if (!variant) {
    return null;
  }
  const availableQuantities = getAvailableQuantities({
    // @todo. auto generated. fix this error
    // @ts-ignore
    quantitiesInCart: currentProductCardItem.cartQuantities,
    // @todo. auto generated. fix this error
    // @ts-ignore
    quantitiesInThisBox: currentProductCardItem.quantitiesInThisBox
  });
  const result = getValidationMessagesForStandaloneItems({
    items: [_objectSpread({}, item, {
      boxItemsId: null,
      quantity: _sum(variant.quantities),
      variants: [variant],
      requiredQuantities: subtractQuantities({
        // @todo. auto generated. fix this error
        // @ts-ignore
        decreasingQuantity: currentProductCardItem.quantitiesItem,
        subtractionQuantity: availableQuantities
      })
    })],
    supplierInventoryLevels,
    stockLevelsByProductIdAndVariantSku,
    ignoreThreshold: true
  });
  const err = result === null || result === void 0 ? void 0 : result[item._id];
  if (!err) {
    return null;
  }
  return err.isSuccessed ? null : err.message;
});
const offsetQuantitiesSelector = createSelector(currentProductCardItemSelector, currentProductCardItem => {
  if (!currentProductCardItem) {
    return [];
  }
  if (!currentProductCardItem.quantitiesInThisBox) {
    const quantitiesItemToUse = currentProductCardItem.quantityPerBox === 0 ? [] : currentProductCardItem.quantitiesItem;
    return subtractQuantities({
      decreasingQuantity: currentProductCardItem.cartQuantities,
      subtractionQuantity: subtractQuantities({
        decreasingQuantity: currentProductCardItem.cartQuantities,
        // @todo. auto generated. fix this error
        // @ts-ignore
        subtractionQuantity: quantitiesItemToUse
      })
    });
  }
  if (!currentProductCardItem.isSelected) {
    return subtractQuantities({
      decreasingQuantity: new Array(
      // @todo. auto generated. fix this error
      // @ts-ignore
      currentProductCardItem.quantitiesItem.length).fill(0),
      subtractionQuantity: currentProductCardItem.quantitiesInThisBox
    }, false);
  }
  if (getTotalCount(currentProductCardItem.quantitiesItem) === 0) {
    return subtractQuantities({
      // @todo. auto generated. fix this error
      // @ts-ignore
      decreasingQuantity: currentProductCardItem.quantitiesItem,
      subtractionQuantity: currentProductCardItem.quantitiesInThisBox
    }, false);
  }
  // @todo. auto generated. fix this error
  // @ts-ignore
  return currentProductCardItem.quantitiesItem.map((currentSelectedQuantity, index) => {
    const quantityInBoxForCurrentSize =
    // @todo. auto generated. fix this error
    // @ts-ignore
    currentProductCardItem.quantitiesInThisBox[index] || 0;
    const quantityInCartForCurrentSize = currentProductCardItem.cartQuantities[index] || 0;
    if (currentSelectedQuantity > quantityInCartForCurrentSize + quantityInBoxForCurrentSize) {
      return quantityInCartForCurrentSize;
    }
    return currentSelectedQuantity - quantityInBoxForCurrentSize;
  });
});
const mapStateToProps = createStructuredSelector({
  errorMessage: errorMessageSelector,
  isOpen: isOpenEditQuantityInCartPopup,
  stockLevelsByVariantSku: stockLevelsByVariantSkuSelector,
  productIsAlwaysInStock: createSelector(currentProductSelector, currentProduct => currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.isAlwaysInStock),
  sizes: createSelector(currentProductSelector, currentProduct => {
    var _currentProduct$size;
    return currentProduct === null || currentProduct === void 0 ? void 0 : (_currentProduct$size = currentProduct.size) === null || _currentProduct$size === void 0 ? void 0 : _currentProduct$size.options;
  }),
  variant: variantSelector,
  sizeInd: createSelector(currentItemSelector, currentItem => (currentItem === null || currentItem === void 0 ? void 0 : currentItem.sizeInd) || 0),
  offsetQuantities: offsetQuantitiesSelector,
  isApparel: createSelector(currentProductSelector, product => {
    if (!product) {
      return false;
    }
    return checkIsApparel({
      designUploadMode: product.designUploadMode,
      hasSize: product.hasSize,
      sizeDependentPrice: product.sizeDependentPrice
    });
  })
});
const mapDispatchToProps = dispatch => ({
  onClose: () => {
    dispatch(closeEditQuantityInCartPopup());
  },
  onQuantitiesChange: quantities => {
    dispatch(editCurrentQuantityInCart(quantities));
  },
  onSave: offsetQuantity => {
    dispatch(saveNewQuantityInCartForItemProductCard(offsetQuantity));
  }
});
export default connect(mapStateToProps, mapDispatchToProps)(EditQuantityInCartForBuildBoxesDrawer);